// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__gsjXu"};